export function find(target: HTMLElement, findEl: HTMLElement): HTMLElement|null {
  if (target === null || target.nodeType !== 1) { return null; }
  if (target === findEl) { return target; }

  let childs: HTMLCollection = target.children;
  for (let i = 0, el = childs[i]; i < childs.length;el = childs[++i]) {
    const f = find(el as HTMLElement, findEl);
    if (f) { return f; }
  }
  return null;
}

/** 對 val 四捨五入取小數點後第 precision 位 */
export function roundDecimal(val: number, precision: number) {
  return Math.round(Math.round(val * Math.pow(10, (precision || 0) + 1)) / 10) / Math.pow(10, (precision || 0));
}

/**
 * 取得元素 px 單位寬度，(解決原本是相對單位尺寸)
 * copy from [here](https://stackoverflow.com/questions/28606058/what-is-the-equivalent-of-height-and-width-of-jquery-in-pure-javascript)
 */
export function getPixelValue(element: any, value: string|number): number {
  if (typeof value === 'number') { return value; }
  if (/^\d+(px)?$/i.test(value)) { return parseInt(value, 10); }
  const style = element.style.left;
  const runtimeStyle = element.runtimeStyle.left;
  element.runtimeStyle.left = element.currentStyle.left;
  element.style.left = value || 0;
  value = element.style.pixelLeft;
  element.style.left = style;
  element.runtimeStyle.left = runtimeStyle;
  return value as number;
}

/**
 * 取得元素的大小(by px)
 * @param el HTML元素
 */
export function getElementStyleSize(el: HTMLElement) {
  if ((window as any).getComputedStyle) {
    const computedStyle = getComputedStyle(el, null);
    const w = computedStyle.width;
    const h = computedStyle.height;
    return {
      w: w === 'auto' ? 0 : roundDecimal(parseFloat(w), 5),
      h: h === 'auto' ? 0 : roundDecimal(parseFloat(h), 5),
    };
  } else {
    return {
      w: roundDecimal(getPixelValue(el, (el as any).currentStyle.width), 5),
      h: roundDecimal(getPixelValue(el, (el as any).currentStyle.height), 5),
    };
  }
}